import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Avatar } from 'components/atoms/avatar';
import {
  CpBody03Secondary,
  CpHeading03Primary,
} from 'components/atoms/customer-portal/typography';
import { CollaborationIconMap } from 'components/organisms/customer-portal/portal-inputs/render-as/collaboration-icon-config-input';
import { CpSectionWrapper } from '../../common';
import { CpLogoWidgetRendererProps } from '../cp-logo-section';

export const CpLogoSectionWrapper = styled(CpSectionWrapper)`
  min-height: 0 !important;
  /* padding-top: var(--cp-spacing-13);
  padding-bottom: var(--cp-spacing-13); */
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  overflow-y: hidden;
  gap: var(--cp-spacing-10);

  @media (max-width: 768px) {
    justify-content: center;
  }

  @media (max-width: 480px) {
    align-items: center;
  }
`;

const Description = styled(CpBody03Secondary)`
  text-align: center;
  width: 768px;

  /* tablet */
  @media (max-width: 768px) {
    width: 70%;
    padding-right: 0;
    text-align: center;
  }

  /* no padding in mobile */
  @media (max-width: 480px) {
    padding-right: 0;
    text-align: center;
    width: 90%;
  }
`;

export const SectionWrapper = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--cp-spacing-09);

  @media (max-width: 480px) {
    width: 90%;
    align-items: center;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cp-spacing-03);

  @media (max-width: 768px) {
    justify-content: center;
    align-items: center;
  }
`;

export const Heading = styled(CpHeading03Primary)`
  text-align: center;
  @media (max-width: 480px) {
    text-align: center;
  }
`;

export const LogoSectionWrapper = styled.div<{ isCollaborationIconAvailable }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ isCollaborationIconAvailable }) =>
    isCollaborationIconAvailable
      ? 'var(--cp-spacing-10)'
      : 'var(--cp-spacing-09)'};
`;

export const LogoWrapper = styled.div`
  width: 100px;
  height: 100px;
`;

export const LogoDivider = styled.div`
  width: 0;
  height: 100px;
  border-right: 1px solid var(--gray-20);
  position: relative;
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: var(--cp-spacing-09);
  width: 66px;
  height: 66px;
  background-color: white;
  border: 1px solid var(--gray-20);
  border-radius: 50%;
  position: absolute;
  top: 16px;
  left: -32px;
`;

export const StyledAvatar = styled(Avatar)`
  width: 100px !important;
  height: 100px !important;
  .ant-avatar-lg {
    width: 100px !important;
    height: 100px !important;
  }

  .ant-avatar-string {
    font-size: 50px;
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const CpLogoWithHeader: React.FC<CpLogoWidgetRendererProps> = ({
  disabled,
  data,
  widget,
}) => {
  const [isIconEnabled, setIsIconEnabled] = React.useState(
    (data?.collaborationIconConfig as any).isIconEnabled as boolean,
  );

  useEffect(() => {
    setIsIconEnabled((data?.collaborationIconConfig as any).isIconEnabled);
  }, [data?.collaborationIconConfig]);

  return (
    <CpLogoSectionWrapper
      paddingY={widget?.widgetDefinition?.styles?.paddingY as number}
      isDisabled={disabled}
      background={widget?.widgetDefinition?.styles?.background as string}
    >
      <Wrapper>
        <SectionWrapper>
          <ContentWrapper>
            <Heading data-cy="cp.logo_with_header.title" autoAdjustColor>
              {data?.title}
            </Heading>
            <Description
              data-cy="cp.logo_with_header.description"
              autoAdjustColor
            >
              {data?.description}
            </Description>
          </ContentWrapper>
        </SectionWrapper>

        <LogoSectionWrapper isCollaborationIconAvailable={isIconEnabled}>
          <LogoWrapper data-cy="cp.logo_with_header.vendor_logo">
            <StyledAvatar
              size="large"
              shape="square"
              key={(data?.vendorLogo as unknown as any).companyId}
              name={(data?.vendorLogo as unknown as any).companyName}
              src={(data?.vendorLogo as unknown as any).companyLogoUrl}
            />
          </LogoWrapper>
          <LogoDivider>
            {isIconEnabled && (
              <LogoContainer data-cy="cp.logo_with_header.connector">
                {
                  CollaborationIconMap[
                    (data.collaborationIconConfig as unknown as any)?.iconType
                  ].largeIcon
                }
              </LogoContainer>
            )}
          </LogoDivider>
          <LogoWrapper data-cy="cp.logo_with_header.customer_logo">
            {data?.customerLogo ? (
              <StyledImage src={data?.customerLogo} />
            ) : (
              <StyledAvatar
                data-cy="cp.logo_with_header.customer_logo"
                size="large"
                shape="square"
                name={data?.customerLogo}
                src={data?.customerLogo}
              />
            )}
          </LogoWrapper>
        </LogoSectionWrapper>
      </Wrapper>
    </CpLogoSectionWrapper>
  );
};
